import React, { useEffect, useState } from "react";
import { Link, useParams, useLocation, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import CryptoJS from "crypto-js";
import AuthLayout from "../components/AuthLayout";
import { resetpassword } from "../components/DbServices";

const ResetPassword = () => {
  const { encryptedId: paramToken } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [token, setToken] = useState(paramToken || "");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  // Fade out the preloader (JQuery integration as per your snippet)


  // Extract token from query string if available
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const queryToken = queryParams.get("token");
    if (queryToken) {
      setToken(queryToken);
    }
  }, [location.search]);

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (newPassword.length < 8) {
      Swal.fire("Error", "New password must be at least 8 characters long!", "error");
      return;
    }

    if (newPassword !== confirmPassword) {
      Swal.fire("Error", "Passwords do not match!", "error");
      return;
    }

    try {
      setLoading(true);
      // Hash the password as per your security requirement
      const encryptedPassword = CryptoJS.SHA256(newPassword).toString();

      const payload = {
        token: token,
        password: encryptedPassword,
      };

      // Dispatch the resetPassword thunk
      //const response = await dispatch(resetPassword(payload)).unwrap();
      const response=await resetpassword(payload)

      if (response?.status === 200) {
        Swal.fire({
          title: "Success!",
          text: "Your password has been reset successfully. Please log in.",
          icon: "success",
          confirmButtonText: "Go to Login",
          confirmButtonColor: "#6D28D9",
          allowOutsideClick: false,
        }).then(() => {
          navigate("/"); 
        });
      } else {
        Swal.fire("Error", response?.message || "Failed to reset password.", "error");
      }
    } catch (error) {
      console.error("Error resetting password:", error);
      const errorMessage = error?.message || error?.data?.message || "Something went wrong!";
      Swal.fire("Error", errorMessage, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Create New Password"
      subtitle="Enter your new secure credentials below"
    >
      <form onSubmit={handleResetPassword}>
        {/* NEW PASSWORD FIELD */}
        <div className="mb-3">
          <label className="form-label small fw-black text-muted mb-2 tracking-wider">NEW PASSWORD</label>
          <div className="input-group">
            <span className="input-group-text bg-light border-light-subtle rounded-start-3 px-3">
              <i className="fas fa-lock text-muted small"></i>
            </span>
            <input
              type={showPassword ? "text" : "password"}
              className="form-control bg-light border-light-subtle py-3 rounded-end-3 shadow-none"
              placeholder="Min 8 characters"
              style={{ fontSize: '14px' }}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>
        </div>

        {/* CONFIRM PASSWORD FIELD */}
        <div className="mb-3">
          <label className="form-label small fw-black text-muted mb-2 tracking-wider">CONFIRM PASSWORD</label>
          <div className="input-group">
            <span className="input-group-text bg-light border-light-subtle rounded-start-3 px-3">
              <i className="fas fa-check-circle text-muted small"></i>
            </span>
            <input
              type={showPassword ? "text" : "password"}
              className="form-control bg-light border-light-subtle py-3 rounded-end-3 shadow-none"
              placeholder="••••••••"
              style={{ fontSize: '14px' }}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
        </div>

        {/* SHOW PASSWORD TOGGLE */}
        <div className="form-check mb-4">
          <input
            className="form-check-input shadow-none"
            type="checkbox"
            id="showPassword"
            checked={showPassword}
            onChange={() => setShowPassword(!showPassword)}
            style={{ cursor: 'pointer' }}
          />
          <label className="form-check-label small text-muted fw-bold" htmlFor="showPassword" style={{ cursor: 'pointer' }}>
            Show Passwords
          </label>
        </div>

        {/* SUBMIT BUTTON */}
        <button
          className="btn w-100 py-3 rounded-pill fw-black text-white shadow-lg border-0 transition-all hover-lift"
          style={{ 
            background: 'linear-gradient(135deg, #6D28D9 0%, #06B6D4 100%)',
            letterSpacing: '1px'
          }}
          disabled={loading || !token}
          type="submit"
        >
          {loading ? (
            <span className="spinner-border spinner-border-sm me-2"></span>
          ) : (
            <>RESET PASSWORD <i className="fas fa-key ms-2"></i></>
          )}
        </button>
      </form>

      {/* FOOTER */}
      <div className="text-center mt-5">
        <p className="text-muted small fw-medium">
          <Link to="/" className="text-primary fw-black text-decoration-none">
            <i className="fas fa-arrow-left me-2"></i> Back to Login
          </Link>
        </p>
      </div>

      <style>{`
        .hover-lift:hover { transform: translateY(-2px); filter: brightness(1.1); transition: all 0.2s; }
        .fw-black { font-weight: 900 !important; }
        .tracking-wider { letter-spacing: 0.05rem; }
        .form-check-input:checked { background-color: #6D28D9; border-color: #6D28D9; }
      `}</style>
    </AuthLayout>
  );
};

export default ResetPassword;